import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import workflowService from '../services/workflowService';
import { queryKeys } from './queryKeys';

export function useWorkflows(options = {}) {
  return useQuery({
    queryKey: queryKeys.workflows.all,
    queryFn: () => workflowService.getWorkflows(),
    staleTime: Infinity,
    ...options,
  });
}

export function useWorkflowDetail(workflowId, options = {}) {
  return useQuery({
    queryKey: queryKeys.workflows.detail(workflowId),
    queryFn: () => workflowService.getWorkflowDetail(workflowId),
    enabled: !!workflowId,
    ...options,
  });
}

export function useCreateWorkflow(options = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: payload => workflowService.createWorkflow(payload),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.workflows.all });
      options.onSuccess?.(...args);
    },
    onError: options.onError,
  });
}

export function useDeleteWorkflow(options = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: workflowId => workflowService.deleteWorkflow(workflowId),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.workflows.all });
      options.onSuccess?.(...args);
    },
    onError: options.onError,
  });
}
